import React, { useContext, useMemo, useState } from 'react'
import { AppContext } from '@state/context'
import { useCurrentUser } from '@hooks/useCurrentUser'
import Heading from '@components/Heading'
import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  DIVIDER_SIZE,
  HEADING_TYPE,
  PANELS,
  TEXT_ALIGN,
  TEXT_SIZES,
} from '@helpers/constants'
import Divider from '@components/Divider'
import ButtonWithLoader from '@components/ButtonWithLoader'
import Text from '@components/Text'
import { useUserSchoolClasses } from '@hooks/useUserSchoolClasses'
import { useDisconnectCustomerSchoolClass } from '@hooks/mutations/useDisconnectCustomerSchoolClass'
import { useNavigate } from 'react-router-dom'
import { useAddToastWithTimer } from '@hooks/useAddToastWithTimer'
import Button from '@components/Button'
import { closePanel } from '@state/actions/panelsActions'

const DeleteMySchoolClassPanel = () => {
  const { currentUser } = useCurrentUser()
  const [, dispatch] = useContext(AppContext)
  const { schoolClasses, isLoading: isLoadingSchoolClasses } =
    useUserSchoolClasses()
  const { post: postDisconnect, isPosting: isPostingDisconnect } =
    useDisconnectCustomerSchoolClass()
  const { addToastWithTimer } = useAddToastWithTimer()
  const navigate = useNavigate()
  const mySchoolClass = useMemo(
    () => schoolClasses?.find((sc) => sc.isPrivate),
    [isLoadingSchoolClasses, schoolClasses]
  )

  const disconnectSchoolClass = async () => {
    const res = await postDisconnect(
      {
        disconnectSchoolClasses: [mySchoolClass.id],
        id: currentUser.id,
      },
      null,
      'Någonting gick fel. Försök igen senare och kontakta oss om felet kvarstår.'
    )

    if (res.success) {
      navigate('lararrum')
      dispatch(closePanel(PANELS.DELETE_MY_SCHOOL_CLASS))
    } else {
      addToastWithTimer(
        'Någonting gick fel. Försök igen senare och kontakta oss om felet kvarstår.',
        true
      )
    }
  }

  return (
    <>
      <div className={'relative'}>
        <div className='absolute top-0 right-0'>
          <Button
            handleClick={() => {
              dispatch(closePanel(PANELS.DELETE_MY_SCHOOL_CLASS))
            }}
            size={BUTTON_SIZE.NO_PADDING}
            icon={'Close'}
          ></Button>
        </div>
      </div>

      <div className={'flex flex-col items-center'}>
        <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.LARGE}>
          Ta bort Min klass
        </Heading>
        <Divider size={DIVIDER_SIZE.SMALL} />

        <Text align={TEXT_ALIGN.LEFT}>
          Är du helt säker på att du vill ta bort klassen?
        </Text>

        <Divider size={DIVIDER_SIZE.SMALL} />

        <ButtonWithLoader
          type={BUTTON_TYPE.ALERT_RED_DARK}
          isLoading={isPostingDisconnect}
          disabledText={'Radera'}
          enabledText={'Radera'}
          disabled={isPostingDisconnect}
          handleClick={async () => {
            await disconnectSchoolClass()
          }}
          nativeTypeAttribute='button'
        />
      </div>
    </>
  )
}

export default DeleteMySchoolClassPanel
